import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { Add } from '@material-ui/icons';
import constants from 'constants/Routes';
import { NewSupplierModal } from 'components/NewSupplier/NewSupplierModal';
import { startLoading, finishLoading } from 'hooks/useProgress';
import {
  createNewSupplier,
  selectSupplier,
} from 'store/suppliersList/ActionCreator';
import { ThunkDispatch } from 'store/StoreConfig';
import { Button } from 'components/common/Button/Button';
import { MergeSuppliers } from 'components/MergeSuppliers';
import { useCanEditSrm } from 'hooks/useHasRole';
import cn from './ActionBar.module.scss';
import { showSnackbarErrorMessage } from 'services/snackbarService';

export const ActionBar = React.memo(() => {
  const canCreate = useCanEditSrm();
  const dispatch = useDispatch<ThunkDispatch>();
  const history = useHistory();

  const [modalOpened, setModalOpened] = useState(false);

  function handleModalClose(): void {
    setModalOpened(false);
  }

  function handleModalOpen(): void {
    setModalOpened(true);
  }

  async function handleSupplierSave(
    supplierName: string,
  ): Promise<void> {
    startLoading();
    try {
      const supplierId = await dispatch(createNewSupplier(supplierName));
      dispatch(selectSupplier(supplierId));
      history.push(`${constants.supplierCard}/${supplierId}`);
      handleModalClose();
    } catch (err) {
      if ((err as any).response?.data) {
        showSnackbarErrorMessage(err);
        throw err;
      }
    } finally {
      finishLoading();
    }
  }

  return (
    <div className={cn.root}>
      {canCreate && (
        <Button
          onClick={handleModalOpen}
          color="primary"
          className={cn.button}
        >
          <div className={cn.buttonText}>
            <Add className={cn.newSupplierPlusIcon} />
            New Supplier
          </div>
        </Button>
      )}
      {canCreate && <MergeSuppliers className={cn.button} />}
      {modalOpened && (
        <NewSupplierModal isOpen={modalOpened} handleClose={handleModalClose} handleSave={handleSupplierSave} />
      )}
    </div>
  );
});
